import styled from '@emotion/styled'
import Image from 'next/legacy/image'
import { pxToRem } from 'utils/styled'

export const SOrderSiteListItem = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const SOrderSiteListItemLogo = styled(Image)`
  object-fit: contain;
  object-position: center;
  width: ${pxToRem(36)}rem;
  height: ${pxToRem(36)}rem;
`
export const SOrderSiteListItemCancel = styled.div`
  display: flex;
  padding: ${pxToRem(10)}rem ${pxToRem(8)}rem;

  & > svg {
    width: ${pxToRem(16)}rem;
    height: ${pxToRem(16)}rem;
  }
`
